module.exports = __webpack_public_path__ + "static/images/distancing.12eab521f2d2c8e3b937702ef43d4bdd.svg";